'use client'

import React, { useState } from 'react'

import { chakra } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { WorkflowIcon } from '../Icon/WorkflowIcon'
import { Tooltip } from '../Tooltip/Tooltip'
import { workflowButtonStyles } from './WorkflowButton.styles'

export interface WorkflowButtonIProps {
  disabled?: boolean
  tooltipLabel?: string
  colorScheme?: ColorScheme
  onClick?: () => void
  /** When true, renders the button in the pressed/active visual state. */
  isActive?: boolean
}

export const WorkflowButton = ({
  disabled = false,
  tooltipLabel,
  colorScheme = 'light',
  onClick,
  isActive = false,
}: WorkflowButtonIProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  return (
    <>
      <chakra.span
        display='inline-flex'
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      >
        <chakra.button
          {...workflowButtonStyles(colorScheme, disabled, isActive)}
          aria-label='Workflows'
          disabled={disabled}
          onClick={disabled ? undefined : onClick}
          type='button'
        >
          <WorkflowIcon color='currentColor' size={14} />
          Workflows
        </chakra.button>
      </chakra.span>
      {tooltipLabel && (
        <Tooltip
          anchorEl={anchorEl}
          colorScheme={colorScheme}
          label={tooltipLabel}
          placement='bottom'
        />
      )}
    </>
  )
}
